import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  ShoppingCart,
  Package,
  CreditCard,
  Wallet,
  Heart,
  Bell,
  Handshake,
  User,
  Settings,
  Headphones,
  LifeBuoy,
} from 'lucide-react';

interface NavItem {
  name: string;
  path: string;
  icon: React.ElementType;
}

const DashboardSidebar: React.FC = () => {
  const location = useLocation();

  const navItems: NavItem[] = [
    { name: 'Dashboard', path: '/dashboard', icon: LayoutDashboard },
    { name: 'Panier', path: '/dashboard/panier', icon: ShoppingCart },
    { name: 'Commandes', path: '/dashboard/commandes', icon: Package },
    { name: 'Transactions', path: '/dashboard/transactions', icon: CreditCard },
    { name: 'Portefeuille', path: '/dashboard/portefeuille', icon: Wallet },
    { name: 'Favoris', path: '/dashboard/favoris', icon: Heart },
    { name: 'Notifications', path: '/dashboard/notifications', icon: Bell },
    { name: 'Partenariat', path: '/dashboard/partenariat', icon: Handshake },
    { name: 'Profil', path: '/dashboard/profil', icon: User },
    { name: 'Paramètres', path: '/dashboard/parametres', icon: Settings },
    { name: 'Support', path: '/dashboard/support', icon: Headphones },
  ];

  const activeIndex = navItems.findIndex(
    (item) => location.pathname === item.path
  );

  return (
    <div className="relative w-72 h-screen bg-primary hidden md:block ">

      {/* HEADER */}
      <div className="flex gap-1.5 py-6 px-4 border-b border-white/10 h-[100px] bg-primary text-white">
        <img
          src="/assets/logo/notextfavicon.jpeg"
          alt="Logo"
          className="h-12 rounded-xl"
        />
        <div className="flex flex-col gap-1.5">
          <span className="font-bold text-2xl">Kayovex</span>
          <span className="text-[10px]">Marketplace</span>
        </div>
      </div>

      {/* SCROLL */}
      <div
        className="overflow-y-auto"
        style={{ height: 'calc(100vh - 100px)', direction: 'rtl' }}
      >
        <div style={{ direction: 'ltr' }}>
          <nav className="py-4 bg-primary space-y-0 text-white">

            {navItems.map((item, index) => {
              const isActive = index === activeIndex;

              return (
                <div
                  key={item.path}
                  className="relative bg-gray-50 text-white space-y-0"
                >

                  {/* TOP DIV — uniquement si actif */}
                  {isActive && (
                    <div className="h-5 bg-primary rounded-br-full" />
                  )}

                  {/* ITEM */}
                  <div className={`pl-2 ${isActive
                      ? 'bg-gradient-to-r from-primary to-white text-secondary'
                      : 'bg-primary text-white'
                    }`}>                    <NavLink
                      to={item.path}
                      end={item.path === '/dashboard'}
                      className={` flex items-center gap-3  px-3 py-4  bg-primary ${isActive
                        ? 'bg-white/80 ml px-2 text-secondary rounded-full rounded-r-none mr-4'
                        : 'text-white ml px-2 bg-gray-50 hover:bg-white/10 hover:ml-1'
                        }
  `}
                    >
                      <item.icon size={22} />
                      <span className="text-base font-medium">{item.name}</span>
                    </NavLink>
                  </div>

                  {/* BOTTOM DIV — uniquement si actif */}
                  {isActive && (
                    <div className="h-5 bg-primary rounded-tr-full" />
                  )}
                </div>
              );
            })}

          </nav>

          {/* HELP CARD */}
          <div className="py-3 px-2">
            <div className="relative overflow-hidden text-white shadow-md rounded-2xl bg-secondary">
              <div className="absolute inset-0 bg-white opacity-10 rounded-2xl"></div>

              <div className="relative z-10 p-4">
                <div className="flex items-center gap-3 mb-3">
                  <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-white/20">
                    <LifeBuoy className="w-5 h-5 text-white" />
                  </div>

                  <div>
                    <h3 className="text-sm font-semibold">Centre d'aide</h3>
                    <p className="text-xs text-white/80">
                      Questions fréquentes & support
                    </p>
                  </div>
                </div>

                <NavLink to="/dashboard/aide">
                  <button className="w-full py-2 text-sm font-medium bg-white text-primary rounded-xl hover:bg-gray-100">
                    Obtenir de l'aide
                  </button>
                </NavLink>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default DashboardSidebar;